<template>
  <Preloader v-if="isLoading" />

  <div v-else class="blog-details-area ptb-100"> 
    
    <div class="breadcrumb-section">
    <div class="container">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0 py-3">
          <li class="breadcrumb-item">
            <router-link to="/">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/resources">Resources</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ this.blog?.one_liner || 'Blog Details' }}
          </li>
        </ol>
      </nav>
    </div>
  </div>
    
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-12">
          <h1 class="mb-3 mt-4 blog-title" style="font-size: 28px;">{{ blog.title }}
          </h1>
          <div class="blog-details-desc">
            <div class="article-image">


              <img :src="backbaseUrl + blog?.image?.url" :alt="blog?.image?.alternativeText || blog?.title + ' - Blog Image' || 'Blog Image'">

            </div>
            <div class="article-content ">
              <div class="entry-meta">
                <ul class="my-3">
                  <li><i class="ri-calendar-2-line"></i>{{ formatDate(blog.updatedAt) }}</li>
                  <!-- <li><i class="ri-message-2-line"></i><router-link to="/blog-grid">(4)
                                            Comments</router-link></li> -->
                                            
                                            <li><i class="ri-book-open-line"></i>{{this.readTime }} Mins Read</li>
                                            <li v-if="blog.ms_blog_categories && blog.ms_blog_categories.length" @click="changeSlug(blog.slug)"
                                              class="chips text-white">
                                              {{ blog.ms_blog_categories[0].name }}
                                            </li>
                 

                  <li style="cursor: pointer;" class="float-end me-2  " title="Share" @click="shareBlog"><i
                      class="ri-stackshare-line"></i>Share
                  </li>
                </ul>
              </div>
            
              <div class="one-liner-content">
                <p>{{ this.blog?.one_liner }}</p>

              </div>
              <div class="content-data" v-html="renderedContent"></div>
            </div>
            <div class="mt-3 mb-3 d-lg-none" >
          <ul class="blog-tags ps-0" style="display: flex;
                flex-wrap: wrap;
                width: 100%;
                gap: 10px;">
               
                <button v-for="(category) in Tags" :key="category.id" style="border: 1px solid #d6cdcd;
              padding: 3px 10px;
              display: inline;margin-bottom: 0px; background: #fff; background-clip: padding-box; border: solid 1px transparent;
              border-radius:20px;  border: 1px solid #ed2775; font-size: 10px;">
                  <router-link :to="{ path: '/resources', query: { slug: category.slug } }">
                    <a style="color:#ed2775;" class="cursor-pointer ">{{ category.name }}
                      <!-- <span class="post-count">(2)</span> -->
                    </a>
                  </router-link>
                </button>
                

                <!-- <li v-for="(category) in categories" :key="category.id">
                                    <a>{{ category.attributes.name }}
                                       
                                    </a>
                                </li> -->
              </ul>
        </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <aside class="widget-area">
            
             <div class="widget widget_categories" style="background: linear-gradient(90deg, #2a2f3d 0%, #ff6c88 100%);" v-if="this.blog?.downloadable_file?.url?.length">
              <h3 class="widget-title" style="color: #fff; font-size: 25px;
    font-weight: 600; text-align: center; ">Access Full Document</h3>
  <p class="text-white text-center" style="font-size: 16px;"> 
Access the full document to explore comprehensive insights and detailed analysis.
</p>
              <ul style="display: flex;
                         flex-wrap: wrap;
                         width: 100%;
                         gap: 10px;
                         justify-content: center;">
                <li style="display: inline;margin-bottom: 0px;
                            background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
                            padding: 12px 30px;
                            border-radius: 99px;">
                  <a
                    class="cursor-pointer"
                    :href="downloadUrl"
                    target="_blank"
                    rel="noopener"
                    style="color: #fff;"
                  >
                    <i class="ri-download-2-line me-2"></i>Download
                  </a>
                </li>
                
              </ul>
            </div>

            <div class="widget widget_meander_software_posts_thumb" style="border-radius: 20px;">
              <h3 class="widget-title">Popular Posts</h3>
              <article class="item" style="cursor: pointer; border-bottom: 1px solid #f23c6930;
                  padding-bottom: 10px; " v-for="(blog) in popularBlogs?.slice(0, 5)" :key="blog.id">
                <div @click="changeSlug(blog?.slug)" class="thumb pointer"><span class="fullimage cover"
                    :style="{ backgroundImage: 'url(' + backbaseUrl + blog?.image?.url + ')' }" role="img"></span></div>
                <div class="info">
                  <h4 class="title usmall">
                    <div class="pointer" @click="changeSlug(blog?.slug)">{{ blog?.title
                    }}</div>
                  </h4>
                  <span class="date"><i class="ri-stack-fill"></i>{{
                   blog?.ms_blog_categories[0]?.name }}</span>
                </div>
              </article>

            </div>

 <div class=" my-3  ">
              <CtcCard :openPopup="openPopup" :cta="blog?.cta" />
            </div>


            <div class="widget widget_categories title-categories" style="background-color: #eee; border-radius: 20px;     box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
              <h3 class="widget-title">Tags</h3>
              <ul class="blog-tags" style="display: flex;
                flex-wrap: wrap;
                width: 100%;
                gap: 10px;">
               
                <button v-for="(category) in Tags" :key="category.id" style="border: 1px solid #d6cdcd;
              padding: 10px 20px;
              display: inline;margin-bottom: 0px; background: #fff; background-clip: padding-box; border: solid 1px transparent;
              border-radius:20px; box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
                box-shadow: rgba(237, 39, 117, -2.75) 0px 0px 3px, rgba(255, 116, 72, 0.2) 1px 0px 8px; font-size: 14px;">
                  <router-link :to="{ path: '/resources', query: { slug: category.slug } }">
                    <a class="cursor-pointer ">{{ category.name }}
                      <!-- <span class="post-count">(2)</span> -->
                    </a>
                  </router-link>
                </button>
                

                <!-- <li v-for="(category) in categories" :key="category.id">
                                    <a>{{ category.attributes.name }}
                                       
                                    </a>
                                </li> -->
              </ul>
            </div>


           
            <div class="widget widget_categories mob-none" v-if="services?.length">
                            <h3 class="widget-title">Services</h3>
                            <ul>
                                <li v-for="(service) in services" :key="service?.slug">
                                    <router-link :to="{path:'/resources',query:{service:service?.slug}}"  >
                                    <a class="cursor-pointer ">{{ service.name }}
                                       
                                    </a>
                                </router-link>
                                </li>
                            </ul>
                        </div>

                        <div class="widget widget_categories mob-none" v-if="technologies?.length">
                            <h3 class="widget-title">Technologies</h3>
                            <ul>
                                <li v-for="(Technologie) in technologies" :key="Technologie?.slug">
                                    <router-link :to="{path:'/resources',query:{technologie:Technologie?.slug}}" >
                                    <a class="cursor-pointer ">{{ Technologie.name }}
                                        
                                    </a>
                                </router-link>
                                </li>
                            </ul>
                        </div>
                      </aside>
          
         
        </div>
        
      </div>
      <div>
        
        <BlogFaq v-if="faq?.length" :faq_Data="faq" />
      </div>
      
      <div class="related-post mt-5" v-if="relatedBlogs?.length">
        <h3 class="title">Related Post </h3>
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 col-sm-12" v-for="(blog) in relatedBlogs.slice(0, 3)" :key="blog.id">
            <div class="single-blog-post">
              <div class="image">
                <div @click="changeSlug(blog.slug)" class="d-block pointer">
                  <img :src="backbaseUrl + blog?.image?.url" :alt="blog?.image?.alternativeText || blog?.title + ' - Related Blog Image' || 'Related Blog Image'">
                </div>
                <!-- <div @click="changeSlug(blog.slug)" class="tag">{{ formatDate(blog.updatedAt) }}</div> -->
              </div>
              <div class="content">
                <ul class="meta">
                  <span class="date"><i class="ri-calendar-2-fill"></i>{{
                    formatDate(blog?.updatedAt) }}</span>

                  <!-- <li><i class="ri-stack-fill"></i> {{ blog?.ms_blog_categories[0]?.name }}</li> -->
                  <!-- <li><i class="ri-message-2-line"></i> <router-link to="/">(0)
                                                        Comment</router-link></li> -->
                </ul>
                <h3>
                  <div class="pointer" @click="changeSlug(blog.slug)">{{ blog.title }}</div>
                </h3>
              </div>
            </div>
          </div>

        </div>
      </div>
     
    </div>
  </div>
</template>
<style>
h1, h2, h3, h4, h5, h6 {
  scroll-margin-top: 100px !important; /* adjust to match your fixed header height */
}
.pointer{
  cursor: pointer !important;
}
.pointer:hover{
  color: #ed2775 !important;
  text-decoration: underline !important;
}
.one-liner-content  {
 margin:20px 0px;
}
.one-liner-content p {
  font-size: 18px !important;
  font-weight: bold;
}

.content-data h4 {
  font-size: 24px !important;
}
.content-data blockquote {
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%
94.18% )!important;
border-radius: 20px;
}
.content-data blockquote p{
color: #fff !important;
}
.content-data blockquote p strong{
color: #fff !important;
}
.content-data p strong {
  font-size: 16px;
}

.content-data p img {
  margin: 0px auto;
  display: block;
}

.article-content h1 {
  font-size: 40px !important;
}

.content-data li {
  font-size: 15px !important;
}
.breadcrumb-section {
  /* background: linear-gradient(90deg, #ed2775 0%, #ff7448 100%); */
  padding: 0;
}
.breadcrumb {
  background: transparent;
  margin-bottom: 0;
  font-size: 1.1rem;
  font-weight: bolder !important;
}
.breadcrumb-item + .breadcrumb-item::before {
  color: linear-gradient(90deg, #ed2775 0%, #ff7448 100%);
  content: ">";
  padding: 0 8px;
}
.breadcrumb-item a {
  color:#ed2775  !important;
  text-decoration: underline;
  transition: color 0.2s;
}
.breadcrumb-item a:hover {
  color:linear-gradient(90deg, #ed2775 0%, #ff7448 100%);
}
.breadcrumb-item.active {
  color: linear-gradient(90deg, #ed2775 0%, #ff7448 100%);
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0,0,0,0.08);
    color: #101720;
}


@media screen and (max-width: 767px) {
    .blog-title {
        font-size: 20px !important;
                padding-top: 10px;
    }
    ol.breadcrumb {
    display: none;
}
.blog-details-desc .article-content .entry-meta ul li {
    margin-bottom: 15px;
}
.blog-details-desc .article-content {
    margin-top: 10px;
}
p {
  font-size: 16px;
  line-height: 26px;
}
.blog-details-desc .article-content .entry-meta ul li {
      margin-bottom: 10px !important;
}
.blog-details-desc .article-content ul, .blog-details-desc .article-content ol {
      margin-top: 10px !important;
    margin-bottom: 20px !important;
}
.blog-details-desc .article-content p a {
      font-size: 13px;
}
.faq-accordion .accordion .accordion__item .accordion__trigger .accordion-title {
  font-size: 15px !important;
}
.blog-details-area {
    padding-bottom: 10px !important; 
}
.ctc-card {
    display: none !important;
}
/* .widget.widget_categories {
    display: none;
} */
.widget.widget_meander_software_posts_thumb {
    display: none;
}
.widget.widget_meander_software_posts_thumb {
    display: none;
}
.title-categories {
  display: none;
}
.mob-none {
  display: none;
}
}

</style>
<script>
import axios from "axios";
import Preloader from '../Layout/Preloader.vue';
import BlogFaq from './Blog_faq.vue';
import CtcCard from '../Common/CtcCard.vue';
import MarkdownIt from 'markdown-it';
import { useGetBlogByCategorySlug, useGetBlogBySlug, useGetBlogs } from '../../services/graphqlService';
import { provideApolloClient,onResult } from '@vue/apollo-composable';

import apolloClient from '../../apollo';
import { toRaw, watchEffect } from "vue";
import markdownItAnchor from 'markdown-it-anchor'
import { injectSchemaMarkup, generateResourceDetailSchema } from "../../utils/schemaUtils";

export default {
  name: 'Details',
  props: {
    openPopup: Function
  },
  components: {
    Preloader,
    BlogFaq,
    CtcCard
  },
  data() {
    return {
      isLoading: true,
      blog: {},
      categories: [],
      services: [],
      technologies: [],
      popularBlogs: [],
      relatedBlogs: [],
      backbaseUrl: 'https://backend.meander.software',
      faq: [],
      Tags: [],
      readTime: 4,
      slug: this.$route.params.slug,
      baseUrl: 'https://content.meander.software',
      md: new MarkdownIt().use(markdownItAnchor, {
  slugify: s => encodeURIComponent(
    String(s).trim().toLowerCase().replace(/[\s]+/g, '-').replace(/[?':!@#%^&*(){}[\]<>.,/\\]/g, '')
  )
}) // Created a new instance of markdown-it

    };
  },
  created: async function () {
    await this.getCategories();
    await this.getService();
    await this.gettechnologies();
    await this.fetchPopularPosts();
    this.isLoading = false;
  },
  watch: {
    '$route.params.slug': {
      immediate: true,
      handler(newSlug) {
        this.getBlog22();
        // fetch related posts if needed
        // Wait for getBlog22 to finish and blog to be set
        setTimeout(() => {
          if (
            this.blog &&
            Array.isArray(this.blog.ms_blog_categories) &&
            this.blog.ms_blog_categories.length > 0
          ) {
            this.fetchRelatedPosts(this.blog.ms_blog_categories[0].name);
          }
        }, 500);
      }
    }
  },
  methods: {
   async calculateReadTime(html) {
      const content =await this.stripHtmlTags(html)
      const wordsPerMinute = 200;
      const text = content.trim();
      const wordCount = text.split(/\s+/).length;
      const time = Math.ceil(wordCount / wordsPerMinute);
      
      this.readTime = time
      return time;
    },
    stripHtmlTags(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    async getBlog22() {
  const slugs = this.$route.params.slug;

  provideApolloClient(apolloClient)(() => {
    const { result, loading, error, onResult } = useGetBlogBySlug(slugs);

    onResult(({ data }) => {
      if (data?.meanderSoftwareBlogs?.length) {
        const blogData = data.meanderSoftwareBlogs[0];
        this.blog = blogData || {};

    

        this.calculateReadTime(this.blog.content);
        this.faq = blogData?.faq;

        // Set SEO meta tags
        this.setMetaTags(this.blog);

        const tag = [
          ...blogData?.ms_blog_categories,
          ...blogData?.ms_blog_industries,
          ...blogData?.ms_blog_services,
          ...blogData?.ms_blog_technologies,
        ];

        this.Tags = toRaw(tag);

        // if (this.blog?.meta_tags) {
        //   this.setMetaTags(this.blog?.meta_tags);
        // }
        
        // Inject schema markup for SEO
        try {
          const schemas = generateResourceDetailSchema(this.blog, this.slug);
          injectSchemaMarkup(schemas);
        } catch (error) {
          console.error('Error injecting resource detail schema:', error);
        }
      }
    });
  });
},
    async getBlog() {
      try {
        const response = await axios.get(`${this.$baseUrl}/blogs?filters[slug]=${this.slug}&populate=*`);
        const { data } = response;
        this.blog = data.data[0] || {};
      } catch (error) {
        console.error(error);
      }
    },

    async fetchRelatedPosts(category) {
      provideApolloClient(apolloClient)(() => {
        const { result, loading, error } = useGetBlogByCategorySlug(category);

        watchEffect(() => {
          // More comprehensi
          if (result?.value?.meanderSoftwareBlogs?.length) {


            this.relatedBlogs = result?.value?.meanderSoftwareBlogs
          }


        });
      });
      // const response = await axios.get(`${this.backbaseUrl}/meanderSoftwareBlogs?pagination[limit]=2&ms_blog_categories=${category}&populate=*`);
      // const { data } = response;
      // this.relatedBlogs = data.data;
    },
    async getCategories() {
      const response = await axios.get(`${this.$baseUrl}/blog-categories`);
      this.categories = response.data.data;
    },
    async getService() {
      const response = await axios.get(`${this.$backendUrl}/api/ms-blog-services`);
      this.services = response.data.data;
    },
    async gettechnologies() {
      const response = await axios.get(`${this.$backendUrl}/api/ms-blog-technologies`);
      this.technologies = response.data.data;
    },
    fetchPopularPosts() {

      let pagination = {
        page: 1,
        pageSize: 5,
      }


      provideApolloClient(apolloClient)(() => {
        const { result, loading, error } = useGetBlogs(pagination);

        watchEffect(() => {
          if (result?.value?.meanderSoftwareBlogs?.length) {
 
// console.log(result?.value?.meanderSoftwareBlogs[0]?.ms_blog_categories[0]?.name);
            this.popularBlogs = result?.value?.meanderSoftwareBlogs;

          }


          this.isLoading = false
        });
      });
      // const response = await axios.get(`${this.$baseUrl}/blogs?pagination[limit]=5&populate=image`);
      // this.popularBlogs = response.data;
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";
      return new Intl.DateTimeFormat('default', { dateStyle: 'long' }).format(date);
    },
    changeSlug(slug) {
      if (slug && slug !== this.$route.params.slug) {
        this.$router.push({ path: `/resource-detail/${slug}` });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    shareBlog() {
      if (navigator.share) {
        const shareData = {
          title: this.blog.title || 'Blog Post',
          text: this.blog.content ? this.blog.content.substring(0, 100) + '...' : 'Check out this blog post',
          url: window.location.href
        };

        navigator.share(shareData)
          .then(() => {
             
          })
          .catch((error) => {
            
            // Fallback: copy to clipboard
            this.copyToClipboard(window.location.href);
          });
      } else {
        // Fallback for browsers that don't support Web Share API
        this.copyToClipboard(window.location.href);
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          alert('Link copied to clipboard!');
        }).catch(() => {
          this.fallbackCopyToClipboard(text);
        });
      } else {
        this.fallbackCopyToClipboard(text);
      }
    },
    fallbackCopyToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        alert('Link copied to clipboard!');
      } catch (err) {
        
      }
      document.body.removeChild(textArea);
    },
    setMetaTags(blog) {
      // console.log(blog,'45454');
      
      // Set the page title
      document.title = blog?.meta_tags?.meta_title || blog?.title || 'Meander Software Blog';
      
      // Helper to set or update a meta tag
      function setMeta(name, content, attr = 'name') {
        let element = document.querySelector(`meta[${attr}="${name}"]`);
        if (!element) {
          element = document.createElement('meta');
          element.setAttribute(attr, name);
          document.head.appendChild(element);
        }
        element.setAttribute('content', content || '');
      }

      // Helper to safely truncate text
      function safeTruncate(text, maxLength) {
        if (!text || typeof text !== 'string') return '';
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
      }

      // Helper to get image URL with fallbacks
     

      // Set basic meta tags with robust fallbacks
      const title = blog?.meta_tags?.meta_title || blog?.title || 'Meander Software Blog';
      const description = blog?.meta_tags?.meta_description || blog?.one_liner || 'Explore our comprehensive insights and resources on software development, technology trends, and industry best practices.';
      const keywords = blog?.meta_tags?.meta_keywords || 'software development, technology resources, programming articles, tech insights, development guides, meander software';
      const imageUrl = this.getImageUrl(blog);

      setMeta('title', title);
      setMeta('description', safeTruncate(description, 300));
      setMeta('keywords', safeTruncate(keywords, 300));

      // Open Graph tags - First priority: Backend og_tags, fallback to computed values
      const ogTitle = blog?.og_tags?.og_title || title;
      const ogDescription = blog?.og_tags?.og_description || safeTruncate(description, 150);
      const ogType = blog?.og_tags?.og_type || 'article';
      const ogUrl = window.location.href; // Use current URL since og_url doesn't exist
      const ogImage = blog?.og_tags?.og_image?.url ? 
                      `${this.backbaseUrl}${blog.og_tags.og_image.url}` : imageUrl;
      const ogImageWidth = '1200'; // Default since og_image_width doesn't exist
      const ogImageHeight = '630'; // Default since og_image_height doesn't exist
      const ogImageAlt = title; // Use title since og_image_alt doesn't exist

      setMeta('og:title', ogTitle, 'property');
      setMeta('og:description', ogDescription, 'property');
      setMeta('og:type', ogType, 'property');
      setMeta('og:url', ogUrl, 'property');
      setMeta('og:image', ogImage, 'property');
      setMeta('og:image:width', ogImageWidth, 'property');
      setMeta('og:image:height', ogImageHeight, 'property');
      setMeta('og:image:alt', ogImageAlt, 'property');

      // Twitter Card tags - First priority: Backend twitter_tags, fallback to computed values
      const twitterTitle = blog?.twitter_tags?.twitter_title || title;
      const twitterDescription = blog?.twitter_tags?.twitter_description || safeTruncate(description, 150);
      const twitterImage = blog?.twitter_tags?.twitter_image?.url ? 
                          `${this.backbaseUrl}${blog.twitter_tags.twitter_image.url}` : imageUrl;
      const twitterImageAlt = title; // Use title since twitter_image_alt doesn't exist
      // const twitterCard = 'summary_large_image'; // Default since twitter_card doesn't exist
      // const twitterSite = '@meandersoftware'; // Default since twitter_site doesn't exist
      // const twitterCreator = '@meandersoftware'; // Default since twitter_creator doesn't exist

      setMeta('twitter:title', twitterTitle, 'name');
      setMeta('twitter:description', twitterDescription, 'name');
      setMeta('twitter:image', twitterImage, 'name');
      setMeta('twitter:image:alt', twitterImageAlt, 'name');
      // setMeta('twitter:card', twitterCard, 'name');
      // setMeta('twitter:site', twitterSite, 'name');
      // setMeta('twitter:creator', twitterCreator, 'name');

      // Update canonical URL
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.setAttribute('href', window.location.href);
      } else {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        canonical.setAttribute('href', window.location.href);
        document.head.appendChild(canonical);
      }
    },

      getImageUrl(blog) {
        // First priority: Use specific OG image from backend
        if (blog?.og_tags?.og_image?.url) {
          return `${this.backbaseUrl}${blog.og_tags.og_image.url}`;
        }
            // Second priority: Use specific Twitter image from backend
    if (blog?.twitter_tags?.twitter_image?.url) {
      return `${this.backbaseUrl}${blog.twitter_tags.twitter_image.url}`;
    }
        // Third priority: Use general meta image from backend
        if (blog?.meta_tags?.meta_image?.url) {
          return `${this.backbaseUrl}${blog.meta_tags.meta_image.url}`;
        }
        // Fourth priority: Use blog image
        if (blog?.image?.url) {
          return `${this.backbaseUrl}${blog.image.url}`;
        }
        return 'https://meander.software/og-default-image.jpg';
      }
  },
  computed: {
    renderedContent() {
      // Always pass a string to MarkdownIt
      return this.md.render(typeof this.blog?.content === 'string' ? this.blog.content : '');
    },
    downloadUrl() {
      return this.blog?.downloadable_file?.url
        ? this.backbaseUrl + this.blog.downloadable_file.url
        : '#';
    }
  }
}
</script>